import $ from 'jquery';
import LazyLoadService from '../_utilities/lazy-module-service';
import { seeMoreClickEvent } from '../_helpers/constants';

export default class EditorialListLoadMore {
  constructor(elm, opts) {
    this.currentPage = opts.currentPage;
    this.hasMultiple = opts.hasMultiple;
    this.$element = $(elm);
    this.service = new LazyLoadService();
    this.itemsSkipped = parseInt(opts.itemsSkipped, 10);
    this.itemsFetched = parseInt(opts.itemsFetched, 10);
  }

  _updateDataJsonAttributes(
    plugin,
    uptSkipValue,
    uptAdvBannerFrequency,
    uptAdvMrecFrequency,
    uptAdvTargeting,
    uptEnableAdv
  ) {
    $.extend(true, plugin.JSON, {
      Module: {
        Skip: uptSkipValue,
        SectionTitle: '',
        ShowLoadMore: true,
        IsLazyLoadCall: true,
        AdvBannerFrequency: uptAdvBannerFrequency,
        AdvMrecFrequency: uptAdvMrecFrequency,
        AdvTargeting: uptAdvTargeting,
        EnableAdv: uptEnableAdv,
      },
    });

    plugin.$target.attr('data-json-module', JSON.stringify(plugin.JSON));
  }

  async init() {
    const that = this;

    const buttonMore = this.$element.find('button')[0];
    const plugin = {};
    plugin.$target = this.$element;

    const dataJson = plugin.$target.attr('data-json-module');
    plugin.JSON = JSON.parse(dataJson);

    const uptSkipValue = this.itemsSkipped + this.itemsFetched;
    const uptAdvBannerFrequency = plugin.JSON.Module.AdvBannerFrequency;
    const uptAdvMrecFrequency = plugin.JSON.Module.AdvMrecFrequency;
    const uptEnableAdv = plugin.JSON.Module.EnableAdv;
    const uptAdvTargeting = plugin.JSON.Module.AdvTargeting;

    this._updateDataJsonAttributes(
      plugin,
      uptSkipValue,
      uptAdvBannerFrequency,
      uptAdvMrecFrequency,
      uptAdvTargeting,
      uptEnableAdv
    );

    $(buttonMore).prop('onclick', null).off('click');

    $(buttonMore).on('click', async function () {
      $(window).trigger(seeMoreClickEvent, {});
      await that.service
        .initByElement(that.hasMultiple, that.$element, true)
        // eslint-disable-next-line promise/always-return
        .then(() => {
          const event = new CustomEvent('load-more-event', { detail: 'completed' });
          document.dispatchEvent(event);
        });
    });
  }
}
